import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/ycuserPayer',
    meta: { title: '权限管理' },
    component: Layout,
    redirect: '/ycuserPayer/list',
    children: [
      {
        path: 'list',
        meta: { title: '权限管理', activeMenu: '/ycuserPayer' },
        component: () => import('@/views/zhyc/userPayer/UserPayer.vue')
      },
      {
        path: 'add',
        meta: { title: '新增权限管理', activeMenu: '/ycuserPayer' },
        component: () => import('@/views/zhyc/userPayer/UserPayerAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑权限管理', activeMenu: '/ycuserPayer' },
        component: () => import('@/views/zhyc/userPayer/UserPayerAdd.vue')
      }
    ]
  },
  {
    path: '/ycuserBond',
    meta: { title: '供应商资金详情' },
    component: Layout,
    redirect: '/ycuserBond/list',
    children: [
      {
        path: 'list',
        meta: { title: '供应商资金详情', activeMenu: '/ycuserBond' },
        component: () => import('@/views/zhyc/userBond/UserBond.vue')
      },
      {
        path: 'detail',
        meta: { title: '供应商资金详情', activeMenu: '/ycuserBond' },
        component: () => import('@/views/zhyc/userBond/UserBondDetail.vue')
      }

    ]
  },
  {
    path: '/ycfundmanage',
    meta: { title: '资金管理' },
    component: Layout,
    redirect: '/ycfundmanage/list',
    children: [
      {
        path: 'list',
        meta: { title: '资金管理', activeMenu: '/ycfundmanage' },
        component: () => import('@/views/zhyc/bondRecord/BondRecord3.vue')
      },
      {
        path: 'detail',
        meta: { title: '资金详情', activeMenu: '/ycfundmanage' },
        component: () => import('@/views/zhyc/bondRecord/BondRecordDetail3.vue')
      },
      {
        path: 'approval',
        meta: { title: '资金审批', activeMenu: '/ycfundmanage' },
        component: () => import('@/views/zhyc/bondRecord/FundApproval.vue')
      },
      {
        path: 'add',
        meta: { title: '资金管理', activeMenu: '/ycfundmanage' },
        component: () => import('@/views/zhyc/bondRecord/BondRecordAdd3.vue')
      }
    ]
  },
  {
    path: '/ycpriceControl',
    meta: { title: '价格管理' },
    component: Layout,
    redirect: '/ycpriceControl/list',
    children: [
      {
        path: 'list',
        meta: { title: '价格管理', activeMenu: '/ycpriceControl' },
        component: () => import('@/views/zhyc/priceControl/PriceControl.vue')
      },
      {
        path: 'detail',
        meta: { title: '价格详情', activeMenu: '/ycpriceControl' },
        component: () => import('@/views/zhyc/priceControl/PriceControlDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑价格', activeMenu: '/ycpriceControl' },
        component: () => import('@/views/zhyc/priceControl/PriceControlEdit.vue')
      }
    ]
  },
  {
    path: '/ycpurchaseDemand',
    meta: { title: '采购询价' },
    component: Layout,
    redirect: '/ycpurchaseDemand/list',
    children: [
      {
        path: 'list',
        meta: { title: '采购询价', activeMenu: '/ycpurchaseDemand' },
        component: () => import('@/views/zhyc/purchaseDemand/PurchaseDemand.vue')
      },
      {
        path: 'add',
        meta: { title: '发布采购询价', activeMenu: '/ycpurchaseDemand' },
        component: () => import('@/views/zhyc/purchaseDemand/PurchaseDemandAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑采购询价', activeMenu: '/ycpurchaseDemand' },
        component: () => import('@/views/zhyc/purchaseDemand/PurchaseDemandAdd.vue')
      }
    ]
  },
  {
    path: '/ycorderManage',
    meta: { title: '采购订单管理' },
    component: Layout,
    redirect: '/ycorderManage/list',
    children: [
      {
        path: 'add',
        meta: { title: '新增采购订单', activeMenu: '/orderManage' },
        component: () => import('@/views/zhyc/orderManage/OrderAdd.vue')
      },
      {
        path: 'list',
        meta: { title: '采购订单管理', activeMenu: '/ycorderManage' },
        component: () => import('@/views/zhyc/orderManage/OrderManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '采购订单详情', activeMenu: '/ycorderManage' },
        component: () => import('@/views/zhyc/orderManage/OrderManageDetail.vue')
      },
      {
        path: 'relation',
        meta: { title: '关联提货单', activeMenu: '/ycorderManage' },
        component: () => import('@/views/zhyc/orderManage/Relation.vue')
      }
    ]
  },
  {
    path: '/ycdeliveryOrder',
    meta: { title: '提货订单管理' },
    component: Layout,
    redirect: '/ycdeliveryOrder/list',
    alias: '/ycorderManage/deliveryOrder',
    children: [
      {
        path: 'list',
        meta: { title: '提货订单管理', activeMenu: '/ycdeliveryOrder' },
        component: () => import('@/views/zhyc/deliveryOrder/DeliveryOrder.vue')
      },
      {
        path: 'add',
        meta: { title: '新增提货订单', activeMenu: '/ycdeliveryOrder' },
        component: () => import('@/views/zhyc/deliveryOrder/thOrderAdd.vue')
      },
      {
        path: 'detail',
        meta: { title: '提货订单详情', activeMenu: '/ycdeliveryOrder' },
        component: () => import('@/views/zhyc/deliveryOrder/DeliveryOrderDetail.vue')
      }

    ]
  },
  {
    path: '/ycDeliveryOrderRelation',
    meta: { title: '导出出库单' },
    component: Layout,
    redirect: '/ycdeliveryOrderRelation/list',
    children: [
      {
        path: 'list',
        meta: { title: '导出出库单', activeMenu: '/deliveryOrderRelation' },
        component: () => import('@/views/zhyc/deliveryOrder/DeliveryOrderRelation.vue')
      },
      {
        path: 'detail',
        meta: { title: '提货订单详情', activeMenu: '/deliveryOrder' },
        component: () => import('@/views/zhyc/deliveryOrder/DeliveryOrderDetail.vue')
      }
    ]
  },
  {
    path: '/ycInvoice',
    meta: { title: '发票管理' },
    component: Layout,
    redirect: '/ycInvoice/newInvoice',
    children: [
      {
        path: 'newInvoice',
        meta: {
          title: '发票管理',
          activeMenu: '/ycInvoice/newInvoice'
        },
        component: () => import('@/views/zhyc/invoiceManage/InvoiceManage.vue')
      },
      {
        path: 'newInvoice/add',
        meta: {
          title: '新增发票',
          activeMenu: '/ycInvoice/newInvoice'
        },
        component: () => import('@/views/zhyc/invoiceManage/InvoiceManageAdd.vue')
      },
      {
        path: 'newInvoice/edit',
        meta: {
          title: '编辑发票',
          activeMenu: '/ycInvoice/newInvoice'
        },
        component: () => import('@/views/zhyc/invoiceManage/InvoiceManageAdd.vue')
      },
      {
        path: 'newInvoice/detail',
        meta: {
          title: '发票详情',
          activeMenu: '/ycInvoice/newInvoice'
        },
        component: () => import('@/views/zhyc/invoiceManage/InvoiceManageDetail2.vue')
      }
    ]
  },
  {
    path: '/ycgoodstransfer',
    component: Layout,
    redirect: '/ycgoodstransfer/list',
    children: [
      {
        path: 'list',
        meta: { title: '货权转移', activeMenu: '/ycgoodstransfer' },
        component: () => import('@/views/orderManage/GoodsTransfer.vue')
      }
    ]
  },
  {
    path: '/ycLossReport',
    component: Layout,
    redirect: '/ycLossReport/list',
    children: [
      // 损耗统计沿用采购订单菜单上下文与按钮权限。
      {
        path: 'list',
        meta: { title: '损耗统计', activeMenu: '/ycLossReport' },
        component: () => import('@/views/zhyc/orderManage/LossReport.vue')
      }
    ]
  }
]
